/**
 * Function for quick order
 */

// keep a track of all eventlisteners
let elementListeners = [];

// render the collection for the quick order page
async function getCollectionsWholesale (collectionList, element = null, isLoadMore = false, cleanup = false) {
  const tempCurrentDiv = document.querySelector('[data-collections-wholesale]');
  if (cleanup) {
    tempCurrentDiv.innerHTML = '';
  }

  const loader = document.querySelector('.wholesale-product__loader');
  if (loader) {
    loader.classList.remove('wholesale-product__loader--hide');
  }

  // Get the collection data from the Shopify API, getting the html
  for(let i = 0; i< collectionList.length; i++) {
    let urlToFetch = '/collections/' + collectionList[i] + '?view=alternate';
    if (element && element.dataset.nextPage) {
      urlToFetch = element.dataset.nextPage;
    }
    const result = await
    fetch(urlToFetch)
      .then(response => {
        if (response.status !== 200) {
          return Promise.reject('error');
        }
        return response.text();
      })
      .then(data => {
          // get the correct position to insert the collection
          let currentDiv = null
          if (isLoadMore) {
            currentDiv = document.querySelector('[data-collection-products="' + collectionList[i] + '"]');
          } else {
            currentDiv = document.querySelector('[data-collections-wholesale]');
          }
          // convert data to html object
          const parser = new DOMParser();
          const htmlObject = parser.parseFromString(data, 'text/html');
          // get the collection items
          let collectionItems = null
          if (isLoadMore) {
            const empty = htmlObject.querySelector('[data-empty]');
            if (!empty) {
              collectionItems = htmlObject.querySelector('[data-collection-products]');
            }
          } else {
            collectionItems = htmlObject.querySelector('[data-collection-container]');
          }

          currentDiv.insertAdjacentHTML('beforeend',collectionItems ? collectionItems.innerHTML : '');

          //check if there is next page
          let nextPage = htmlObject.querySelector('[data-next-page]');
          const currentLoadMore = document.querySelector('[data-load-more-collection-handle="' + collectionList[i] + '"]');
          if (currentLoadMore && currentLoadMore.dataset.variantId !== undefined) {
            elementListeners.push(currentLoadMore.dataset.variantId);
          }
          if (nextPage) {
            nextPage = nextPage.dataset.nextPage;
            if (currentLoadMore) {
              currentLoadMore.dataset.nextPage = nextPage;
              currentLoadMore.classList.remove('wholesale-product__load-more--hide');
            }
          } else {
            if (currentLoadMore) {
              currentLoadMore.classList.add('wholesale-product__load-more--hide');
            }
          }
      })
      .catch(error => {
        console.log("🚀 ~ getCollectionsWholesale ~ error:", error)
      });
    }

    if (loader) {
      loader.classList.add('wholesale-product__loader--hide');
    }

}

// delete extra item
function deleteExtraItem(e) {
  const extraItem = document.querySelector('[data-product-options-unique-id="' + e.dataset.deleteExtra + '"]');
  extraItem.remove();
  updatePopupQuantity();
}

// add grind type to product form
function updateProductForm(e) {
  document.querySelectorAll('.shopify-product-form')

  const productForm = document.querySelectorAll('.shopify-product-form');
  productForm.forEach(form => {
    const grindType = form.querySelector('[data-grind-type]');
    if (grindType) {
      if (e.value) {
        grindType.value = e.value;
        grindType.name = 'properties[Mouture/Grind]';
      }else{
        grindType.value = '';
        grindType.name = 'properties[Mouture/Grind]';
      }
    }
  })
}

// The grind <select> shows its first option ("Aucune mouture / No grind") as
// selected on load, but the hidden line-item property is only written when the
// select fires a change event. A customer who leaves the default never triggers
// it, so the property was submitted empty, which the order-tagging Flow reads as
// a real grind. Sync the hidden input to the select's current value on load so
// the visible default is what gets recorded.
function initGrindDefault() {
  document.querySelectorAll('.product-info__grind-type select').forEach(select => {
    updateProductForm(select);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGrindDefault);
} else {
  initGrindDefault();
}

// add eventlisteners to the add another buttons
function loadEvents() {
  const addAnotherButtons = document.querySelectorAll('[data-variant-add-another]');
  if (addAnotherButtons) {
    addAnotherButtons.forEach(button => {
      if (!hasEventListener(button.dataset.variantId)) {
        elementListeners.push(button.dataset.variantId);
        button.addEventListener('click', function() {
          const variantId = this.dataset.variantId;
          const optionsElement = document.querySelector('[data-product-options="' + variantId + '"]');
          // clone the options element
          const newOptionsElement = optionsElement.cloneNode(true);

          // generate a random number using minutes, seconds and milliseconds
          const random = new Date().getMinutes() + '' + new Date().getSeconds() + '' + new Date().getMilliseconds();
          const newVariantId = `${variantId}-${random}`;
          newOptionsElement.querySelector('[data-variant-quantity]').dataset.variantQuantity = newVariantId;
          newOptionsElement.querySelector('[data-variant-quantity]').value = 0;
          newOptionsElement.querySelector('.wholesale-product__delete').classList.remove('wholesale-product--hide');
          newOptionsElement.querySelector('.wholesale-product__delete button').dataset.deleteExtra = newVariantId;
          newOptionsElement.dataset.productOptions = newVariantId;
          newOptionsElement.dataset.productOptionsUniqueId = newVariantId;
          // remove errors
          const selects = newOptionsElement.querySelectorAll('select');
          selects.forEach(select => {
            select.classList.remove('wholesale-product--error');
            select.dataset.productOptionsUniqueId = newVariantId;
          });

          // update the onclick event for the button with attribute data-variant-decrement
          newOptionsElement.querySelector('[data-variant-decrement]').dataset.variantId = newVariantId;
          newOptionsElement.querySelector('[data-variant-increment]').dataset.variantId = newVariantId;
          const optionsParent = document.querySelector('[data-product-options-wrapper="' + variantId + '"]');
          optionsParent.appendChild(newOptionsElement);

          if (newVariantId !== undefined && !hasEventListener(newVariantId)) {
            elementListeners.push(newVariantId);
          }
        });
      }
    });
  }
}

// function to control and validate when the quantity is updated
function updateQuantityWholesale(upDown, element) {
  const productId = element.dataset.variantId;
  const quantityInput = document.querySelector('[data-variant-quantity="' + productId + '"]');
  const quantity = parseInt(quantityInput.value);
  if (upDown === 1) {
    quantityInput.value = quantity + 1;
  } else {
    if (quantity > 0) {
      quantityInput.value = quantity - 1;
    } else {
      quantityInput.value = 0;
    }
  }
  checkSelects(productId);
  updatePopupQuantity();
}

// function to control and validate when the size and grind is updated
function changeSelect(element) {
  const productId = element.target.dataset.productOptionsUniqueId;
  checkSelects(productId);
  togglePopupButton();
}

// function to control and validate when the size and grind is updated
function checkSelects(productId) {
  // remove all errors
  const options = document.querySelector('[data-product-options-unique-id="' + productId + '"]');
  const selects = options.querySelectorAll('select');
  selects.forEach(select => {
    select.classList.remove('wholesale-product--error');
  });

  const quantityInput = options.querySelector('[data-variant-quantity]');

  // validate selected options
  if (quantityInput.value > 0) {
    // check selects
    let selected = true;
    selects.forEach(select => {
      if (select.value === '') {
        selected = false;
        select.classList.add('wholesale-product--error');
      } else {
        select.classList.remove('wholesale-product--error');
      }
    });
  }
}

// update the quantity in the popup and show the popup
function updatePopupQuantity() {
  const allQuantities = document.querySelectorAll('[data-variant-quantity]');
  let items = 0;
  allQuantities.forEach(quantity => {
    items += parseInt(quantity.value);
  });
  const popupQuantity = document.querySelector('[data-popup-wholesale-quantity]');
  popupQuantity.innerHTML = items === 1 ? `${items} ${quantityOne}` : `${items} ${quantityOther}`
  const popup = document.querySelector('[data-popup-wholesale]');
  if (items == 0) {
    popup.classList.remove('wholesale-product__popup--show');
  } else {
    popup.classList.add('wholesale-product__popup--show');
  }

  // update the cart button
  togglePopupButton()
}

// reset the popup button
function resetPopupButton() {
  const popupQuantity = document.querySelector('[data-popup-wholesale-quantity]');
  popupQuantity.innerHTML = ''
  const popup = document.querySelector('[data-popup-wholesale]');
  popup.classList.remove('wholesale-product__popup--show');
}

// disable/enable the add to cart button in the popup
function togglePopupButton() {
  const allProducts = document.querySelectorAll('[data-collection-products]');
  let disableButton = false;
  allProducts.forEach(product => {
    if (disableButton) return;
    // get all options
    const allOptions = product.querySelectorAll('[data-product-options]');
    allOptions.forEach(oneOption => {
      if (disableButton) return;
      // get all selects
      const sizeSelected = oneOption.querySelector('[data-variant-select]');
      let variantToAdd = sizeSelected && sizeSelected.value ? sizeSelected.value : '';

      const grindSelected = oneOption.querySelector('[data-variant-grind-type]');
      let grindToAdd = grindSelected ? grindSelected.value : null;

      const quantity = oneOption.querySelector('[data-variant-quantity]').value;

      if (variantToAdd === '' && quantity > 0) {
        disableButton = true;
        return;
      }
      if (grindToAdd !== null && grindToAdd === '' && quantity > 0) {
        disableButton = true;
        return;
      }
    })
    document.querySelector('[data-popup-wholesale-add-to-cart]').disabled = disableButton;
  });
}

// function to show error message on wholesale page
function toggleWholesaleError(action) {
  const errorElement = document.querySelector('[data-collections-wholesale-error]');
  if (action === 'hide') {
    errorElement.classList.remove('wholesale-product__error-message--show');
    return;
  }
  errorElement.classList.add('wholesale-product__error-message--show');
}

// control the load more prducts
async function loadMoreWholesale(collection, element = null, isLoadMore = false, cleanup = false, expandAll = true) {
  // validate if the add to cart popup is opened
  const popup = document.querySelector('[data-popup-wholesale]');
  if (popup.classList.contains('wholesale-product__popup--show')) {
    toggleWholesaleError('show');
    return;
  }

  toggleWholesaleError('hide');
  // remove all elementListeners
  elementListeners = [];
  await getCollectionsWholesale(collection, element, isLoadMore, cleanup);

  // expand all products
  if (expandAll) {
    const allProducts = document.querySelectorAll('[data-collection-products]');
    allProducts.forEach(product => {
      expandThis(product.dataset.collectionProducts);
    });
  }

  setTimeout(() => {
    loadEvents();
    const allLoadExtra = document.querySelectorAll('.wholesale-product__another');
    allLoadExtra.forEach((element) => {
      element.classList.remove('wholesale-product__another--hide');
    })
  }, 1000);
}

// check if an element has an event listener
function hasEventListener(id) {
  return elementListeners.indexOf(id) > -1;
}

// function to control the tabs
function updateCurrentTab(element) {
  // validate if the add to cart popup is opened
  const popup = document.querySelector('[data-popup-wholesale]');
  if (popup.classList.contains('wholesale-product__popup--show')) {
    toggleWholesaleError('show');
    return;
  }

  const currentTab = document.querySelector('.wholesale-product__tab--active');
  currentTab.classList.remove('wholesale-product__tab--active');
  element.classList.add('wholesale-product__tab--active');
  resetPopupButton();
}

// function to add all products to the cart
function wholesaleAddToCart() {
  const allProducts = document.querySelectorAll('[data-collection-products]');
  let stopAddToCart = false;

  const listOfProducts = [];

  // disable add to cart button
  const addToCartButton = document.querySelector('.wholesale-product__button-add');
  const addToCartButtonText = document.querySelector('.wholesale-product__popup-text');
  const addToCartLoader = document.querySelector('.wholesale-product__popup-loader');
  addToCartButton.disabled = true;
  addToCartButtonText.classList.add('wholesale-product--hide');
  addToCartLoader.classList.remove('wholesale-product--hide');

  allProducts.forEach(product => {
    if (stopAddToCart) return;
    // get all options
    const allOptions = product.querySelectorAll('[data-product-options]');
    allOptions.forEach(oneOption => {
      if (stopAddToCart) return;
      // get all selects
      const sizeSelected = oneOption.querySelector('[data-variant-select]');
      let variantToAdd = sizeSelected && sizeSelected.value ? sizeSelected.value : '';

      const grindSelected = oneOption.querySelector('[data-variant-grind-type]');
      let grindToAdd = grindSelected ? grindSelected.value : null;

      const quantity = oneOption.querySelector('[data-variant-quantity]').value;

      if (variantToAdd === '' && quantity > 0) {
        stopAddToCart = true;
        return;
      }
      if (grindToAdd !== null && grindToAdd === '' && quantity > 0) {
        stopAddToCart = true;
        return;
      }

      // add the variant to the array
      if (quantity > 0) {
        listOfProducts.push({
          id: variantToAdd,
          properties: {
            'Mouture/Grind': grindToAdd
          },
          quantity: quantity
        });
      }
    })
  });

  if (listOfProducts.length > 0) {
    const data = {
      items: listOfProducts
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(data => {
      // open cart drawer
      resetPopupButton();
      resetSelections();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      addToCartButton.disabled = false;
      addToCartButtonText.classList.remove('wholesale-product--hide');
      addToCartLoader.classList.add('wholesale-product--hide');
      document.querySelector('[cart-button]').click();
    })
    .catch((error) => {
      console.error('Error:', error);
      addToCartButton.disabled = false;
      addToCartButtonText.classList.remove('wholesale-product--hide');
      addToCartLoader.classList.add('wholesale-product--hide');
    });
  }
}

// function to reset the selections
function resetSelections() {
  const allProducts = document.querySelectorAll('[data-collection-products]');
  allProducts.forEach(product => {
    // get all options
    const allOptions = product.querySelectorAll('[data-product-options]');
    allOptions.forEach(oneOption => {
      // get all selects
      const sizeSelected = oneOption.querySelector('[data-variant-select]');
      if (sizeSelected && sizeSelected.options.length > 1) {
        sizeSelected.value = '';
      }

      const grindSelected = oneOption.querySelector('[data-variant-grind-type]');
      if (grindSelected && grindSelected.options.length > 1) {
        grindSelected.value = 'Aucune mouture / No grind';
      }

      const quantity = oneOption.querySelector('[data-variant-quantity]');
      if (quantity) {
        quantity.value = 0
      }
    })
  })
}

/**
 * Function for main collection coffees
 */

function loadCollectionWithFilter(urlToFetch) {
  fetch(urlToFetch)
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('error');
      }
      return response.text();
    })
    .then(data => {
      // convert data to html object
      const parser = new DOMParser();
      const htmlObject = parser.parseFromString(data, 'text/html');

      // replace coffees filters
      const coffeeFilters = document.querySelector('.coffees-collection__nav-drawer');
      const newCoffeeFilters = htmlObject.querySelector('.coffees-collection__nav-drawer');
      coffeeFilters.innerHTML = newCoffeeFilters.innerHTML;

      // replace products
      const currentProducts = document.querySelector('[data-collection-products-container]');
      const newProducts = htmlObject.querySelector('[data-collection-products-container]');
      currentProducts.innerHTML = newProducts.innerHTML;
    })
    .catch(error => {
      console.log("🚀 ~ loadCollectionWithFilter ~ error:", error)
    });
}

function expandThis(handle) {
  const currentElement = document.querySelector('[data-collection-products="' + handle + '"]');
  const plusButton = document.querySelector('[data-collection-plus="' + handle + '"]');
  const dashButton = document.querySelector('[data-collection-dash="' + handle + '"]');
  const pagination = document.querySelector('[data-collection-pagination="' + handle + '"]');
  if (currentElement) {
    currentElement.classList.add('wholesale-product__accordion--show')
    if (plusButton) {
      plusButton.classList.add('wholesale-product--hide');
    }
    if (dashButton) {
      dashButton.classList.remove('wholesale-product--hide');
    }
    if (pagination) {
      pagination.classList.remove('wholesale-product--hide');
    }
  }
}

function collapseThis(handle) {
  const currentElement = document.querySelector('[data-collection-products="' + handle + '"]');
  const plusButton = document.querySelector('[data-collection-plus="' + handle + '"]');
  const dashButton = document.querySelector('[data-collection-dash="' + handle + '"]');
  const pagination = document.querySelector('[data-collection-pagination="' + handle + '"]');
  if (currentElement) {
    currentElement.classList.remove('wholesale-product__accordion--show')
    if (plusButton) {
      plusButton.classList.remove('wholesale-product--hide');
    }
    if (dashButton) {
      dashButton.classList.add('wholesale-product--hide');
    }
    if (pagination) {
      pagination.classList.add('wholesale-product--hide');
    }
  }
}

/**
 * Pandectes cookie banner language fix
 * Pandectes stores bilingual text as "French||English" - this extracts the correct language
 */
(function() {
  var locale = document.documentElement.lang || "fr";
  var isFrench = locale.indexOf("fr") === 0;

  function fixPandectesBanner() {
    var banner = document.getElementById("pandectes-banner");
    if (!banner) return false;
    if (banner.innerHTML.indexOf("||") === -1) return true;

    // Use regex to remove ||English portion (or ||French if English locale)
    if (isFrench) {
      banner.innerHTML = banner.innerHTML.replace(/\|\|[^<"]*/g, "");
    } else {
      banner.innerHTML = banner.innerHTML.replace(/>[^<]*\|\|/g, ">").replace(/\|\|/g, "");
    }
    return true;
  }

  // Poll until banner is fixed (Pandectes loads async)
  var attempts = 0;
  var interval = setInterval(function() {
    attempts++;
    if (fixPandectesBanner() || attempts > 100) {
      clearInterval(interval);
    }
  }, 100);
})();

/**
 * ReCharge subscription widget translation
 * The new <recharge-subscription-widget> renders inside a shadow root and Recharge's
 * admin only supports a single locale, so we translate the rendered text on EN pages.
 */
(function() {
  var locale = document.documentElement.lang || "fr";
  if (locale.indexOf("fr") === 0) return;

  var translations = {
    "Ajouter au panier": "Add to cart",
    "Abonnez-vous et économisez": "Subscribe and save",
    "Détails de l'abonnement": "Subscription details",
    "Comment fonctionne l'abonnement": "How subscriptions work",
    "Les produits sont livrés automatiquement selon la fréquence choisie. Sans obligation, vous pouvez modifier ou annuler votre abonnement à tout moment.": "Products are delivered automatically at your chosen frequency. No commitment - you can modify or cancel your subscription at any time.",
    "Plus populaire": "Most popular",
    "Changez la fréquence ou le contenu de votre commande à tout moment": "Change the frequency or contents of your order at any time",
    "Ne manquez plus jamais de café": "Never run out of coffee again",
    "Fréquence de livraison": "Delivery frequency",
    "Livraison chaque semaine": "Every week",
    "Livraison chaque jour": "Every day",
    "Livraison chaque mois": "Every month",
    "Achat unique": "One-time purchase"
  };

  var regexTranslations = [
    { pattern: /Économisez\s+(\d+)\s*%/g, replacement: "Save $1%" },
    { pattern: /Livraison chaque (\d+) semaines/g, replacement: "Every $1 weeks" },
    { pattern: /Livraison chaque (\d+) jours/g, replacement: "Every $1 days" },
    { pattern: /Livraison chaque (\d+) mois/g, replacement: "Every $1 months" }
  ];

  var observedRoots = new WeakSet();

  function collectShadowRoots(root, roots) {
    var elements = root.querySelectorAll("*");
    for (var i = 0; i < elements.length; i++) {
      var sr = elements[i].shadowRoot;
      if (sr) {
        roots.push(sr);
        collectShadowRoots(sr, roots);
      }
    }
  }

  function translateRoot(root) {
    var translated = false;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      var original = node.textContent;
      var updated = original;
      for (var i = 0; i < regexTranslations.length; i++) {
        updated = updated.replace(regexTranslations[i].pattern, regexTranslations[i].replacement);
      }
      for (var fr in translations) {
        if (updated.indexOf(fr) !== -1) {
          updated = updated.split(fr).join(translations[fr]);
        }
      }
      if (updated !== original) {
        node.textContent = updated;
        translated = true;
      }
    }
    return translated;
  }

  function translateWidget() {
    var host = document.querySelector("recharge-subscription-widget");
    if (!host || !host.shadowRoot) return false;

    var roots = [host.shadowRoot];
    collectShadowRoots(host.shadowRoot, roots);

    var translated = false;
    roots.forEach(function(root) {
      if (translateRoot(root)) translated = true;
      if (!observedRoots.has(root)) {
        observedRoots.add(root);
        new MutationObserver(function() { translateWidget(); })
          .observe(root, { childList: true, subtree: true, characterData: true });
      }
    });

    return translated;
  }

  var attempts = 0;
  var interval = setInterval(function() {
    attempts++;
    if (translateWidget() || attempts > 100) {
      clearInterval(interval);
    }
  }, 100);
})();

/**
 * ReCharge subscription widget: require explicit frequency selection
 *
 * The widget defaults to "Subscription" with the first frequency pre-selected,
 * which causes occasional accidental subscriptions. This forces the customer to
 * actively pick a frequency (or switch to one-time) before adding to cart.
 *
 * Source of truth is the inner <select> the customer actually sees, not the
 * external hidden <input name="selling_plan">. Recharge sometimes resets that
 * input to its default plan when it re-renders the widget (e.g., after the
 * cart drawer opens following an add-to-cart), even when our placeholder
 * option is the one displayed. We re-sync input -> select at submit time.
 *
 * The widget element itself is stable across re-renders, but its inner shadow
 * DOM (rc-selling-plans, <select>, radios) is recreated when Recharge re-runs
 * its render cycle. A persistent shadow-root MutationObserver re-applies the
 * placeholder and re-attaches listeners whenever fresh elements appear.
 */
(function() {
  var PLACEHOLDER_VALUE = "__csh_none__";
  var locale = document.documentElement.lang || "fr";
  var isFR = locale.indexOf("fr") === 0;

  var MESSAGES = isFR
    ? {
        placeholder: "Sélectionnez la fréquence de livraison",
        error: "Veuillez sélectionner la fréquence de livraison ou opter pour un achat unique."
      }
    : {
        placeholder: "Select a delivery frequency",
        error: "Please select a delivery frequency or choose a one-time purchase."
      };

  function getWidget() {
    return document.querySelector("recharge-subscription-widget");
  }

  function getInnerSelect(widget) {
    if (!widget || !widget.shadowRoot) return null;
    var plans = widget.shadowRoot.querySelector("rc-selling-plans");
    if (!plans || !plans.shadowRoot) return null;
    return plans.shadowRoot.querySelector('select[name="rc_plan"]');
  }

  function getPurchaseOption(widget) {
    if (!widget || !widget.shadowRoot) return null;
    var checked = widget.shadowRoot.querySelector('input[name="purchaseOption"]:checked');
    return checked ? checked.value : null;
  }

  // Cart drawer upsells inject extra .shopify-product-form elements after an
  // add-to-cart, so identify the product form by the only thing unique to it:
  // the selling_plan input that Recharge writes into.
  function getForm() {
    var input = document.querySelector('input[name="selling_plan"]');
    if (input) {
      var owner = input.closest("form.shopify-product-form");
      if (owner) return owner;
    }
    return document.querySelector("form.shopify-product-form");
  }

  function getSellingPlanInput(form) {
    return form ? form.querySelector('input[name="selling_plan"]') : null;
  }

  function findPlaceholder(select) {
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === PLACEHOLDER_VALUE) return select.options[i];
    }
    return null;
  }

  function createPlaceholder(select) {
    var opt = document.createElement("option");
    opt.value = PLACEHOLDER_VALUE;
    opt.textContent = MESSAGES.placeholder;
    opt.disabled = true;
    opt.hidden = true;
    select.insertBefore(opt, select.firstChild);
    return opt;
  }

  // Apply placeholder unless the customer has already picked a real frequency
  // during this widget's lifetime. Crucially idempotent: if the dropdown is
  // already in the desired state we do NOT mutate it. Mutating the <select>
  // while the customer is actively interacting (native dropdown open) cancels
  // their selection and was the cause of "can't pick an option" reports.
  function applyPlaceholderState(widget) {
    var select = getInnerSelect(widget);
    if (!select) return false;
    if (widget.__cshUserPicked) return false;

    var placeholder = findPlaceholder(select);
    var input = getSellingPlanInput(getForm());

    // Already in placeholder state — only correct the external input if it drifted
    if (placeholder && select.value === PLACEHOLDER_VALUE && placeholder.selected) {
      if (input && input.value) input.value = "";
      return true;
    }

    if (!placeholder) placeholder = createPlaceholder(select);
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].selected) select.options[i].selected = false;
      if (select.options[i].hasAttribute("selected")) select.options[i].removeAttribute("selected");
    }
    placeholder.selected = true;
    select.value = PLACEHOLDER_VALUE;
    if (input) input.value = "";
    return true;
  }

  function ensureErrorEl(form) {
    var el = form.querySelector(".csh-frequency-error");
    if (el) return el;
    el = document.createElement("div");
    el.className = "csh-frequency-error";
    el.setAttribute("role", "alert");
    el.setAttribute("aria-live", "polite");
    el.style.cssText =
      "display:none;color:#572932;background:#FAF6ED;border:1px solid #572932;" +
      "padding:10px 14px;border-radius:4px;font-size:14px;line-height:1.4;" +
      "margin-block-start:0.75rem;font-family:Lato,sans-serif;";
    var buyButtons = form.querySelector("buy-buttons");
    if (buyButtons && buyButtons.parentNode) {
      buyButtons.parentNode.insertBefore(el, buyButtons.nextSibling);
    } else {
      form.appendChild(el);
    }
    return el;
  }

  function showError(form) {
    var el = ensureErrorEl(form);
    el.textContent = MESSAGES.error;
    el.style.display = "block";
  }

  function hideError(form) {
    var el = form.querySelector(".csh-frequency-error");
    if (el) el.style.display = "none";
  }

  function attachSelectListener(widget) {
    var select = getInnerSelect(widget);
    if (!select || select.__cshListenerAttached) return;
    select.__cshListenerAttached = true;
    select.addEventListener("change", function() {
      var form = getForm();
      var input = getSellingPlanInput(form);
      if (select.value === PLACEHOLDER_VALUE) {
        widget.__cshUserPicked = false;
        widget.__cshPickedValue = null;
        if (input) input.value = "";
      } else {
        widget.__cshUserPicked = true;
        widget.__cshPickedValue = select.value;
        if (input) input.value = select.value;
        if (form) hideError(form);
      }
    });
  }

  function attachRadioListeners(widget) {
    if (!widget.shadowRoot) return;
    var radios = widget.shadowRoot.querySelectorAll('input[name="purchaseOption"]');
    radios.forEach(function(radio) {
      if (radio.__cshListenerAttached) return;
      radio.__cshListenerAttached = true;
      radio.addEventListener("change", function(e) {
        var form = getForm();
        if (e.target.value === "onetime") {
          if (form) hideError(form);
        } else if (e.target.value === "subscription") {
          // Toggling back to subscription must re-prompt the customer
          widget.__cshUserPicked = false;
          widget.__cshPickedValue = null;
        }
      });
    });
  }

  // Restore the customer's previously picked frequency if Recharge drifted
  // back to its own default during a re-render.
  function syncPickedSelection(widget) {
    var select = getInnerSelect(widget);
    if (!select || !widget.__cshPickedValue) return;
    if (select.value === widget.__cshPickedValue) return;
    var matched = false;
    for (var i = 0; i < select.options.length; i++) {
      var matches = select.options[i].value === widget.__cshPickedValue;
      select.options[i].selected = matches;
      if (matches) matched = true;
    }
    if (matched) {
      select.value = widget.__cshPickedValue;
      var input = getSellingPlanInput(getForm());
      if (input) input.value = widget.__cshPickedValue;
    }
  }

  function initializeWidget(widget) {
    if (widget.__cshUserPicked) {
      syncPickedSelection(widget);
    } else {
      applyPlaceholderState(widget);
    }
    attachSelectListener(widget);
    attachRadioListeners(widget);
  }

  // Block submission in capture phase, before Prestige's product-form handler.
  // The inner <select> is the source of truth — the hidden input may have been
  // overwritten by Recharge to a default plan we never intended.
  document.addEventListener("submit", function(event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains("shopify-product-form")) return;
    // Only validate subscription-capable forms; upsell forms in the cart
    // drawer share the same class but have no selling_plan input.
    var input = getSellingPlanInput(form);
    if (!input) return;
    var widget = getWidget();
    if (!widget) return;
    if (getPurchaseOption(widget) !== "subscription") return;

    var select = getInnerSelect(widget);
    var hasValidSelection = select && select.value && select.value !== PLACEHOLDER_VALUE;

    if (!hasValidSelection) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(form);
      var buttons = form.querySelectorAll('button[type="submit"]');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].removeAttribute("disabled");
        buttons[i].removeAttribute("aria-busy");
      }
      return;
    }

    // Visible selection wins: align the hidden input in case Recharge drifted
    if (input.value !== select.value) {
      input.value = select.value;
    }
  }, true);

  // After a successful add-to-cart, reset our picked state so the customer is
  // prompted again on their next item.
  document.documentElement.addEventListener("variant:add", function() {
    var widget = getWidget();
    if (widget) {
      widget.__cshUserPicked = false;
      widget.__cshPickedValue = null;
    }
  });

  // Continuous reconciliation. Recharge re-renders its widget on radio
  // toggles, variant changes, and after the cart drawer opens. Each render
  // creates new <select> and radio elements inside nested shadow roots that
  // are not reachable through a single outer MutationObserver, so we just
  // re-run our (idempotent) initialization on a tight interval. Cheap and
  // immune to race conditions in Recharge's render cycle.
  setInterval(function() {
    var widget = getWidget();
    if (widget) initializeWidget(widget);
  }, 150);
})();
